var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memberRebate min-height"},[_c('div',{staticClass:"memberContent"},[_c('UserInfo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }